// extracted by mini-css-extract-plugin
export default {"share-button":"sharebutton_share-button__+44M8"};